import { render, staticRenderFns } from "./ServiceProviderMetrics.vue?vue&type=template&id=751e6a50&scoped=true&"
import script from "./ServiceProviderMetrics.vue?vue&type=script&lang=ts&"
export * from "./ServiceProviderMetrics.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProviderMetrics.vue?vue&type=style&index=0&id=751e6a50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751e6a50",
  null
  
)

export default component.exports